import * as React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackActivity } from "@/utils/trackActivity";

export const SlideValidatorView = ({ onBack }) => {
  React.useEffect(() => {
    trackActivity("view_module", "slide_validator");
  }, []);

  const apiUrl = process.env.REACT_APP_BACKEND_URL || "";

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="slide-validator-view">
      <header className="border-b bg-white sticky top-0 z-10 flex-shrink-0">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={onBack} data-testid="slide-validator-back">
            <ArrowLeft className="h-4 w-4 mr-1" />
            Volver
          </Button>
          <div className="h-5 w-px bg-slate-200" />
          <span className="text-sm font-medium text-slate-700">Slide Validator</span>
        </div>
      </header>
      <iframe
        src={`/slide-validator.html?api=${encodeURIComponent(apiUrl)}`}
        className="flex-1 w-full border-0"
        style={{ minHeight: "calc(100vh - 49px)" }}
        title="Slide Validator"
      />
    </div>
  );
};
